import React, { useState, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { currencyOptions } from '../constants';

import BaseInput from './BaseInput';
import BaseInputProps from './BaseInputProps';

export interface NumericMoneyInputProps extends BaseInputProps {
  large?: boolean;
  currencyField?: string;
  inputProps?: JSX.IntrinsicElements["input"];
}

export default function NumericMoneyInput({ currencyField = 'currency', inputProps, ...baseProps }: NumericMoneyInputProps) {
  const { name } = baseProps;
  const { setValue, watch } = useFormContext();
  const [displayValue, setDisplayValue] = useState('');
  const [isFocused, setIsFocused] = useState(false);

  const value = watch(name);
  const currency = watch(currencyField);

  useEffect(() => {
    const formattedValue = value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    setDisplayValue(formattedValue || '');
  }, [value, currency]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const unformattedValue = event.target.value.replace(/\D/g, '');
    setValue(name, unformattedValue, { shouldValidate: true });

    setDisplayValue(unformattedValue.replace(/\B(?=(\d{3})+(?!\d))/g, ","));
  };

  const currencySymbol = `${currencyOptions.find((option) => option.value === currency)?.label.split(" ")[0] || ""  } `;

  return (
    <BaseInput isFocused={isFocused} {...baseProps}>
      <input
        value={`${currencySymbol}${displayValue}`.trim()}
        onChange={handleChange}
        id={name}
        name={name}
        type="text"
        className="mt-2 text-base p-2 block w-full rounded-md border-0 text-limed-spruce-800 shadow-sm ring-1 ring-inset ring-porcelain-300 placeholder:text-porcelain-400 focus:ring-2 focus:ring-inset focus:ring-bondi-blue-600"
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        {...inputProps}
      />
    </BaseInput >
  );
}
